import { TEXTS } from '@/views/PesosCocidos/cookedWeightsConstants'
import { getRawPortion, roundDownToGram } from '@/utils/mealServingTotals'
import { fillTemplate } from '@/views/PesosCocidos/textTemplate'

const SINGLE_UNIT = 1
const ENDS_IN_VOWEL = /[aeiouáéíóú]$/i
const ENDS_IN_FEMININE = /a$/i
const VOWEL_PLURAL_SUFFIX = 's'
const CONSONANT_PLURAL_SUFFIX = 'es'

function pluralOf (name) {
  return `${name}${ENDS_IN_VOWEL.test(name) ? VOWEL_PLURAL_SUFFIX : CONSONANT_PLURAL_SUFFIX}`
}

function describeUnits (units, unitName) {
  if (!unitName) {
    return String(units)
  }
  return `${units} ${units === SINGLE_UNIT ? unitName : pluralOf(unitName)}`
}

function hasValue (value) {
  return value !== null && value !== undefined
}

function describeEach (units, unitName) {
  if (units <= SINGLE_UNIT || !unitName) {
    return ''
  }
  return ENDS_IN_FEMININE.test(unitName) ? TEXTS.EACH_FEMININE_SUFFIX : TEXTS.EACH_MASCULINE_SUFFIX
}

function describeCooked (portion, units, unitName) {
  if (!hasValue(portion.cooked_min_unit_grams)) {
    return ''
  }
  const cooked = fillTemplate(TEXTS.RAW_PORTION_COOKED, { grams: roundDownToGram(portion.cooked_min_unit_grams) })
  return `${cooked}${describeEach(units, unitName)}`
}

export function describeRawPortionCell (group, calorieId) {
  const portion = getRawPortion(group, calorieId)
  if (!portion || !hasValue(portion.units)) {
    return null
  }
  const units = Number(portion.units)
  const unitName = (group.portion_unit_name || '').trim()
  return { unitsText: describeUnits(units, unitName), cookedText: describeCooked(portion, units, unitName) }
}
